import { formatRegion } from "utils/formatRegion";
import { RootState } from "../../reducers";
import { KeyPair } from "./types";
import { createSelector } from "reselect";

// export const keyPairsSelector = (state: RootState): TableKeyPair[] | null =>
//   state.security.keyPairs?.map((keypair) => ({
//     ...keypair,
//     id: keypair.name,
//     region: formatRegion(keypair.region)
//   })) || null;

const getKeyPairs = (state: RootState) => state.security.keyPairs;
export const keyPairsSelector = createSelector([getKeyPairs], (keyPairs) => {
  return keyPairs
    ? keyPairs.map((keypair) => ({
        ...keypair,
        id: keypair.name,
        region: formatRegion(keypair.region)
      }))
    : null;
});

export const keyPairSelector = (state: RootState): KeyPair | null =>
  state.security.keyPair;

export const areKeyPairsLoadingSelector = (state: RootState): boolean =>
  state.security.areKeyPairsLoading;

// export const isKeyPairLoadingSelector = (state: RootState): boolean =>
//   state.security.isKeyPairLoading;

export const isKeyPairCreatingSelector = (state: RootState): boolean =>
  state.security.isKeyPairCreating;

export const isKeyPairDeletingSelector = (state: RootState): boolean =>
  state.security.isKeyPairDeleting;

export const isPublicKeyAddingSelector = (state: RootState): boolean =>
  state.security.isPublicKeyAdding;
